import React from 'react'
import './mission.scss'

import VO_QUESTION_MARK from '../../../../assets/VO_QUESTION_MARK.svg'

const mission = () => {
  return (
    <div className="mission">
      <div className="mission__wrapper">
        <h2 className="primary__heading">Why Virtual Enterprise</h2>
        <p>
          At Virtual Enterprise, we work diligently around the clock 24/7/365 to help our clients succeed. 
          We are a team of smart, personable, off-site receptionists providing companies of all types and sizes throughout the US, Canada, UK and the Caribbean with richer more customized experience.
        </p>
        <p>
          In a friendly, courteous, and professional manner, our virtual receptionists answer your phone calls. 
          We connect you to your callers. We provide your current and potential customers with helpful information when you can't be reached. 
          We get to know your business, so you can trust us to provide the professional image and information you require. 
          We do everything you'd expect a great receptionist to do except we're off-site. Basically, we work for you, just not in your office. 
          Your callers can't tell the difference.
        </p>
        <h2 className="primary__heading">Mission</h2>
        <p>
          Virtual Enterprise Group LLC promises to provide businesses with top quality technology and exemplary answering services solutions. Our solutions will give clients the greatest chance to reduce start‐up and operational costs while allowing them to concentrate fully on their core business.
        </p>
      </div>
    </div>
  )
}

export default mission
